// Spiegelt apps/api/src/rbac/rbac.constants.ts. Weicht die Liste ab, fehlt der
// Bereich in der Rechte-Matrix — und niemand kann die Rechte dafür pflegen,
// obwohl der Server sie auswertet. („calls" hat keine Matrix-Pflege: die
// Sichtbarkeit von Anrufen haengt am Kontakt, nicht an einer eigenen Zelle.)
export const ENTITY_TYPES = [
  "contacts",
  "contracts",
  "risks",
  "vorgaenge",
  "damages",
  "invoices",
  // „CO intern" (PO 09.09.2026). KEINE eigene Tabelle: Der Eintrag existiert,
  // damit die Rechte-Matrix eine Spalte dafür bekommt — durchgesetzt wird das
  // Recht auf den KONTAKT-Zeilen (apps/api/src/coIntern.ts). Anders als bei
  // den übrigen Bereichen wirkt hier auch die Spalte „Bearbeiten": Sie
  // entscheidet, wer die CO-Zugehörigkeit in der Kontaktakte pflegen darf.
  "cointern",
] as const;
export type EntityType = (typeof ENTITY_TYPES)[number];

export const ENTITY_ACTIONS = ["create", "read", "update", "delete"] as const;
export type EntityAction = (typeof ENTITY_ACTIONS)[number];

export const ENTITY_LABELS: Record<EntityType, string> = {
  contacts: "Kontakte",
  contracts: "Verträge",
  risks: "Risiken",
  vorgaenge: "Vorgänge",
  damages: "Schäden",
  invoices: "Zahlungsverkehr",
  cointern: "CO intern",
};

export const ACTION_LABELS: Record<string, string> = {
  create: "Erstellen",
  read: "Lesen",
  update: "Bearbeiten",
  delete: "Löschen",
};

export const ALL_PERMISSIONS: string[] = ENTITY_TYPES.flatMap((e) =>
  ENTITY_ACTIONS.map((a) => `${e}:${a}`),
);

export const APP_ROLES = ["admin", "gfgl", "mitarbeiter", "service"] as const;
export type AppRole = (typeof APP_ROLES)[number];

export const TEAM_ROLES = ["teamleiter", "teammitglied"] as const;
export type TeamRole = (typeof TEAM_ROLES)[number];
